import "core-js/modules/web.timers.js";
import { SButton } from '@strana-artw/ui-kit';
export default {
  name: 'UploadDocumentsSuccess',
  components: {
    SButton: SButton
  },
  data: function data() {
    return {
      timer: undefined,
      time: 4
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.timer = setInterval(function () {
        if (!_this.time) {
          _this.close();
        }
        _this.time--;
      }, 1000);
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    close: function close() {
      this.$emit('exit');
    }
  }
};